<div class="padded-content legal-content">
  <h1>Danke für deine Registrierung!</h1>
  <p>Bitte <span class="emphasized">bestätige die Registrierung</span> mit dem Link, den wir soeben auf {{ email ? 'die' : 'deine' }} Email-Adresse <span class="emphasized">{{ email }}</span> gesendet haben.</p>
</div>
